import { FC } from 'react';
import { Control, UseFormHandleSubmit } from 'react-hook-form';
import { Link } from 'react-router-dom';
import {
    AccentButton,
    ErrorMessage,
    FormColumn,
    FormDescriptionColumn,
    FormSection,
    Input,
    SelectInput,
} from '../../../common/components';
import modelOptions from '../../../common/data/models.json';
import { useOrgs } from '../../../common/hooks';

interface Props {
    control: Control<any>;
    handleSubmit: UseFormHandleSubmit<any>;
    onSubmit: (data: any) => void;
    errors: any;
    error?: string;
    loading?: boolean;
    isEdit?: boolean;
}

const DeviceForm: FC<Props> = ({ control, handleSubmit, onSubmit, errors, error, loading }) => {
    const { orgOptions } = useOrgs({ fetchDataOptions: true });

    return (
        <form className="flex flex-col space-y-6 divide-y" onSubmit={handleSubmit(onSubmit)}>
            <ErrorMessage message={error} />
            <FormSection>
                <FormDescriptionColumn
                    title="Informações do dispositivo"
                    description="O parceiro poderá ser associado ao dispositivo
          posteriormente"
                />
                <FormColumn>
                    <Input
                        control={control}
                        name="serial_number"
                        label="Número de série"
                        placeholder="GT"
                        error={errors?.serial_number}
                    />
                    <SelectInput
                        control={control}
                        name="model"
                        label="Modelo"
                        error={errors?.model?.value}
                        options={modelOptions}
                    />
                    <Input
                        control={control}
                        name="battery_slot_quantity"
                        label="Número de slots"
                        type="number"
                        error={errors?.battery_slot_quantity}
                        disabled
                    />
                    <SelectInput
                        control={control}
                        name="org_id"
                        label="Parceiro (opcional)"
                        error={errors?.org_id?.value}
                        hasEmptyOption={true}
                        emptyOptionLabel="Sem parceiro"
                        options={orgOptions}
                    />
                </FormColumn>
            </FormSection>
            <div className="flex justify-end items-center pt-7 text-sm">
                <Link to="/devices" className="px-7 py-2 font-bold">
                    Cancelar
                </Link>
                <AccentButton type="submit" loading={loading} className="px-4 py-2 ml-3 w-max">
                    Salvar
                </AccentButton>
            </div>
        </form>
    );
};

export default DeviceForm;
